export default __webpack_public_path__ + "static/media/trash-files.699653cd.svg";